
import { Vue, Component, Prop } from "vue-property-decorator";
import { CreateElement } from "vue";
import { IEmail } from "@/models/emails";

@Component
export default class UCopyEmailLink extends Vue {
  // Props
  @Prop({ default: "" })
  public email!: IEmail | string;

  // Render
  public render(h: CreateElement) {
    const email = (this.email as IEmail)?.email || (this.email as string);
    if (!email)
      return h("span", { staticClass: "has-text-grey" }, [
        this.$t("_.no_email_address").toString()
      ]);
    return h("b-tooltip", {
      props: {
        label: this.$t("_action.copy_to_clipboard"),
        type: "is-dark",
        size: "is-small"
      },
      scopedSlots: {
        default: () =>
          h(
            "u-link",
            {
              props: this.$attrs,
              on: {
                click: (event: Event) => {
                  event.stopPropagation();
                  this.$copyToClipboard(email);
                }
              }
            },
            [email]
          )
      }
    });
  }
}
